import { useStore } from '@/common/util/store'

export const useLoadingProgress = () => {
  const store = useStore()
  const showLoadingProgress = () => {
    store.commit('showLoadingProgress', true)
  }

  const hideLoadingProgress = () => {
    store.commit('hideLoadingProgress', false)
  }

  return {
    showLoadingProgress,
    hideLoadingProgress,
  }
}
